import { Chart } from 'chart.js/auto';
import { registerables } from 'chart.js';
Chart.register(...registerables);
